<app-card *ngIf="showView" [cardBodyClasses]="'pt-0'" [cardClasses]="'mt-7'" [header]="true" cardHeaderTitle="Produk Program Marketing">
  <ng-container cardBody>
    <ng-container *ngIf="data | async as data">
      <app-note-view
        *ngIf="!!data.length"
        [color]="'info'"
        [classNoteView]="'mb-7 animation animation-fade-in'"
        [icon]="STRING_CONSTANTS.ICON.IC_INFORMATION"
        [text]="'QTY produk hadiah dapat berubah mengikuti pilihan produk yang dipenuhi.'"
      />

      <div *ngFor="let item of data; let i = index; last as isLast">
        <div class="d-flex justify-content-between mb-7">
          <div class="d-flex align-items-center gap-5">
            <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_PROMO" class="svg-icon svg-icon-24"></span>
            <h5 class="fw-bolder mb-0">{{ item.program_marketing_name }}</h5>
          </div>
          <a (click)="handleDetail(item)" class="text-info fw-bolder text-decoration-underline cursor-pointer">Lihat Detail Program</a>
        </div>

        <ng-container *ngTemplateOutlet="(isLoading | async) ? loaderSectionTpl : viewProductTpl; context: { $implicit: item }" />

        <hr *ngIf="!isLast" class="my-7" />
      </div>
    </ng-container>

    <ng-container *ngIf="(isLoading | async) && !(data | async)?.length" [ngTemplateOutlet]="loaderSectionTpl"></ng-container>
    <ng-container *ngIf="(isLoading | async) === false && !(data | async)?.length" [ngTemplateOutlet]="viewNoProductTpl"></ng-container>
  </ng-container>
</app-card>

<ng-template #loaderSectionTpl>
  <div class="d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center gap-5">
      <app-skeleton-text [count]="1" [type]="'image'" [width]="95" [height]="15" />
      <app-skeleton-text [count]="1" [type]="'text'" [width]="120" [height]="15" />
    </div>
    <app-skeleton-text [count]="1" [type]="'text'" [width]="95" [height]="15" />
  </div>
</ng-template>

<ng-template #viewProductTpl let-item>
  <app-note-view
    *ngIf="!isSO && item.product_list.length > 0 && item.product_list[0].available_stock <= 0"
    [classNoteView]="'border-0 mb-6'"
    [color]="'danger'"
    [icon]="STRING_CONSTANTS.ICON.IC_DANGER"
    [text]="'Stok tidak tersedia untuk memenuhi produk hadiah, produk hadiah akan dikembalikan ke produk menunggu.'"
  />

  <div *ngIf="checkProductList(item.product_list); else viewNoProductTpl">
    <div *ngFor="let product of item.product_list" class="mb-4">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center gap-5">
          <img [alt]="'image product'" [src]="product.product_image" class="img-product-card border-radius-8 img-thumbnail" (error)="handleNoImage($event)" />
          <div class="fw-bolder {{ !isSO && product.available_stock <= 0 ? 'text-gray-400' : '' }}">{{ product.product_name }}</div>
        </div>
        <div class="w-qty my-auto {{ !isSO && product.available_stock <= 0 ? 'text-gray-400' : '' }}">{{ product.qty_outstanding }} {{ product.sale_unit }}</div>
      </div>

      <div *ngIf="!!product.note" class="my-4">
        <div class="text-primary fw-bolder">Catatan :</div>
        <div class="">{{ product.note }}</div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewNoProductTpl>
  <div class="d-flex justify-content-between mb-4">
    <div class="d-flex align-items-center gap-5">
      <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_EMPTY_PROMAG" class="img-product-card border-radius-8"></span>
      <div>QTY {{ isSO ? 'SO' : '' }} Dipenuhi belum memenuhi syarat Program</div>
    </div>
  </div>
</ng-template>

<app-modal-detail-promag #modalDetail [haveValue]="true" />
